import React, { useState } from 'react';
import { Layout as AntLayout, Menu, Button } from 'antd';
import {
  DashboardOutlined,
  BarChartOutlined,
  DatabaseOutlined,
  UserOutlined,
  MessageOutlined,
  PhoneOutlined,
  LogoutOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const { Header, Sider, Content } = AntLayout;

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAdmin, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const adminMenuItems = [
    {
      key: '/admin',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => navigate('/admin'),
    },
    {
      key: '/admin/analytics',
      icon: <BarChartOutlined />,
      label: 'Analytics',
      onClick: () => navigate('/admin/analytics'),
    },
    {
      key: '/admin/batches',
      icon: <DatabaseOutlined />,
      label: 'Batches',
      onClick: () => navigate('/admin/batches'),
    },
    {
      key: '/admin/users',
      icon: <UserOutlined />,
      label: 'Users',
      onClick: () => navigate('/admin/users'),
    },
  ];

  const superAdminMenuItems = [
    {
      key: '/superadmin/global-settings',
      icon: <SettingOutlined />,
      label: 'Global Settings',
      onClick: () => navigate('/superadmin/global-settings'),
    },
  ];

  const userMenuItems = [
    {
      key: '/numbers',
      icon: <PhoneOutlined />,
      label: 'Numbers',
      onClick: () => navigate('/numbers'),
    },
    {
      key: '/sms',
      icon: <MessageOutlined />,
      label: 'SMS Messages',
      onClick: () => navigate('/sms'),
    },
  ];

  const isSuperAdmin = user?.role === 'superadmin';

  let menuItems = userMenuItems;
  if (isSuperAdmin) {
    menuItems = [...superAdminMenuItems, ...adminMenuItems];
  } else if (isAdmin) {
    menuItems = adminMenuItems;
  }

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed} style={{ position: 'relative' }}>
        <div style={{
          padding: collapsed ? '12px 8px' : '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255, 255, 255, 0.1)',
          margin: collapsed ? '8px' : '16px',
          borderRadius: 6
        }}>
          {collapsed ? (
            <img
              src="/cartex_logo.png"
              alt="Cartex"
              style={{ width: '32px', height: 'auto' }}
            />
          ) : (
            <img
              src="/cartex_logo.png"
              alt="Cartex Logo"
              style={{ maxWidth: '100%', height: 'auto', maxHeight: '50px' }}
            />
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
        />
        {/* Version indicator */}
        <div style={{
          position: 'absolute',
          bottom: 16,
          left: 0,
          right: 0,
          textAlign: 'center',
          fontSize: 11,
          color: 'rgba(255, 255, 255, 0.45)',
          padding: '8px'
        }}>
          {collapsed ? 'v1.0.2' : 'Version 1.0.2'}
        </div>
      </Sider>
      <AntLayout>
        <Header style={{
          padding: '0 24px',
          background: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ fontSize: 16, fontWeight: 500 }}>
            Welcome, {user?.username} {isSuperAdmin ? '(SuperAdmin)' : isAdmin ? '(Admin)' : ''}
          </div>
          <Button icon={<LogoutOutlined />} onClick={handleLogout}>
            Logout
          </Button>
        </Header>
        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 }}>
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
